import {
  GpSurfacesMapDepartment,
  GpSurfacesMapMapDepartment,
  GpSurfacesMapMetricMode,
  GpSurfacesMapProjection,
  GpSurfacesMapViewMode,
} from '../types/gp-surfaces-map';

export function buildMapDepartments(
  actualDepartments: GpSurfacesMapDepartment[],
  projection: GpSurfacesMapProjection | null | undefined,
  viewMode: GpSurfacesMapViewMode,
): GpSurfacesMapMapDepartment[] {
  const actualByCode = new Map(
    actualDepartments.map((department) => [department.code, department]),
  );
  const projectionByCode = new Map(
    (projection?.departments ?? []).map((department) => [
      department.code,
      department,
    ]),
  );
  const codes = new Set([
    ...actualDepartments.map((department) => department.code),
    ...(projection?.departments ?? []).map((department) => department.code),
  ]);

  return [...codes].sort().map((code) => {
    const actual = actualByCode.get(code);
    const projected = projectionByCode.get(code);
    const actualArea = actual?.total_area ?? 0;
    const combinedArea = projected?.combined_area ?? actualArea;
    const isProjectionView = viewMode === 'with_projection' && projection;

    return {
      code,
      name: actual?.name ?? projected?.name ?? code,
      total_area: actualArea,
      actual_area: actualArea,
      map_value: isProjectionView ? combinedArea : actualArea,
      projected_area: projected?.projected_area,
      projected_volume_t: projected?.projected_volume_t,
      combined_area: combinedArea,
      parcelle_count: actual?.parcelle_count ?? 0,
      ilot_count: actual?.ilot_count ?? 0,
      carbon_points: isProjectionView
        ? (projected?.carbon_points ?? actual?.carbon_points ?? 0)
        : (actual?.carbon_points ?? 0),
      analysis_count: isProjectionView
        ? (projected?.analysis_count ?? actual?.analysis_count ?? 0)
        : (actual?.analysis_count ?? 0),
      granulo_points: isProjectionView
        ? (projected?.granulo_points ?? actual?.granulo_points ?? 0)
        : (actual?.granulo_points ?? 0),
      granulo_analysis_count: isProjectionView
        ? (projected?.granulo_analysis_count ??
          actual?.granulo_analysis_count ??
          0)
        : (actual?.granulo_analysis_count ?? 0),
      total_sampling_points: isProjectionView
        ? (projected?.total_sampling_points ??
          actual?.total_sampling_points ??
          0)
        : (actual?.total_sampling_points ?? 0),
      total_analysis_count: isProjectionView
        ? (projected?.total_analysis_count ??
          actual?.total_analysis_count ??
          0)
        : (actual?.total_analysis_count ?? 0),
    };
  });
}

export function applyMapMetric(
  departments: GpSurfacesMapMapDepartment[],
  metricMode: GpSurfacesMapMetricMode,
): GpSurfacesMapMapDepartment[] {
  return departments.map((department) => ({
    ...department,
    map_value:
      metricMode === 'carbon_points'
        ? department.carbon_points
        : metricMode === 'analysis_count'
          ? department.analysis_count
          : metricMode === 'granulo_points'
            ? department.granulo_points
            : metricMode === 'granulo_analysis_count'
              ? department.granulo_analysis_count
              : metricMode === 'total_sampling_points'
                ? department.total_sampling_points
                : metricMode === 'total_analysis_count'
                  ? department.total_analysis_count
                  : department.map_value,
  }));
}
